export default __webpack_public_path__ + "static/media/lunch1.f83ea2ce.png";